import getReducer from '../getReducer';
import assign from 'object-assign';

import { DEPARTMENT_TREE_REQUEST, DEPARTMENT_TREE_SUCCESS, DEPARTMENT_TREE_FAILURE } from '../../action/department/tree';
import { DEPARTMENT_INFO_REQUEST, DEPARTMENT_INFO_SUCCESS, DEPARTMENT_INFO_FAILURE } from '../../action/department/info';
import { POSITION_GET_ALL_REQUEST, POSITION_GET_ALL_SUCCESS, POSITION_GET_ALL_FAILURE } from '../../action/position/getall';
import { USER_GET_ALL_REQUEST, USER_GET_ALL_SUCCESS, USER_GET_ALL_FAILURE } from '../../action/user/getall';
import { COMPANY_GET_ALL_REQUEST, COMPANY_GET_ALL_SUCCESS, COMPANY_GET_ALL_FAILURE } from '../../action/company/getall';
import { DEPARTMENT_ADD_REQUEST, DEPARTMENT_ADD_SUCCESS, DEPARTMENT_ADD_FAILURE } from '../../action/department/add';
import { DEPARTMENT_UPDATE_REQUEST, DEPARTMENT_UPDATE_SUCCESS, DEPARTMENT_UPDATE_FAILURE } from '../../action/department/update';
import { DEPARTMENT_DEL_REQUEST, DEPARTMENT_DEL_SUCCESS, DEPARTMENT_DEL_FAILURE } from '../../action/department/del';
import { DEPARTMENT_DEL_USER_REQUEST, DEPARTMENT_DEL_USER_SUCCESS, DEPARTMENT_DEL_USER_FAILURE } from '../../action/department/delUser';
import { USER_DEL_REQUEST, USER_DEL_SUCCESS, USER_DEL_FAILURE } from '../../action/user/del';
import { ROLE_LIST_REQUEST, ROLE_LIST_SUCCESS, ROLE_LIST_FAILURE } from '../../action/role/list';
import { ROLE_TREE_REQUEST, ROLE_TREE_SUCCESS, ROLE_TREE_FAILURE } from '../../action/role/tree';
import { USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS, USER_UPDATE_FAILURE } from '../../action/user/update';
import { ROLE_ADD_REQUEST, ROLE_ADD_SUCCESS, ROLE_ADD_FAILURE } from '../../action/role/add';
import { ROLE_Edit_REQUEST, ROLE_Edit_SUCCESS, ROLE_Edit_FAILURE } from '../../action/role/edit';
import { ROLE_DEL_REQUEST, ROLE_DEL_SUCCESS, ROLE_DEL_FAILURE } from '../../action/role/del';

import { ORGANIZATION_USER_GLOBAL_INQUIRE_REQUEST, ORGANIZATION_USER_GLOBAL_INQUIRE_SUCCESS, ORGANIZATION_USER_GLOBAL_INQUIRE_FAILURE } from '../../action/organization/globalInquire'


function index(state = {
	showLoading: false,
	departmentTree: null,
	departmentInfo: null,
	filterUserDepartment: {
		user: [],
		department: []
	}
}, action) {
	switch (action.type) {
		case DEPARTMENT_TREE_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_TREE_SUCCESS:
			return assign({}, state, {
				departmentTree: action.response.result.departmentTree
			});
		case DEPARTMENT_TREE_FAILURE:
			return assign({}, state, {

			});
		case DEPARTMENT_INFO_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_INFO_SUCCESS:
			return assign({}, state, {
				departmentInfo: action.response.result.departmentInfo
			});
		case DEPARTMENT_INFO_FAILURE:
			return assign({}, state, {

			});
		case POSITION_GET_ALL_REQUEST:
			return assign({}, state, {

			});
		case POSITION_GET_ALL_SUCCESS:
			return assign({}, state, {
				positions: action.response.result.positions
			});
		case POSITION_GET_ALL_FAILURE:
			return assign({}, state, {

			});
		case USER_GET_ALL_REQUEST:
			return assign({}, state, {

			});
		case USER_GET_ALL_SUCCESS:
			return assign({}, state, {
				users: action.response.result.users
			});
		case USER_GET_ALL_FAILURE:
			return assign({}, state, {

			});
		case COMPANY_GET_ALL_REQUEST:
			return assign({}, state, {

			});
		case COMPANY_GET_ALL_SUCCESS:
			return assign({}, state, {
				companies: action.response.result.companies
			});
		case COMPANY_GET_ALL_FAILURE:
			return assign({}, state, {

			});
		case DEPARTMENT_ADD_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_ADD_SUCCESS:
			return assign({}, state, {
			});
		case DEPARTMENT_ADD_FAILURE:
			return assign({}, state, {

			});

		//部门更新
		case DEPARTMENT_UPDATE_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_UPDATE_SUCCESS:
			return assign({}, state, {
			});
		case DEPARTMENT_UPDATE_FAILURE:
			return assign({}, state, {

			});

		//部门删除
		case DEPARTMENT_DEL_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_DEL_SUCCESS:
			return assign({}, state, {
			});
		case DEPARTMENT_DEL_FAILURE:
			return assign({}, state, {

			});

		//删除部门员工
		case DEPARTMENT_DEL_USER_REQUEST:
			return assign({}, state, {

			});
		case DEPARTMENT_DEL_USER_SUCCESS:
			return assign({}, state, {
			});
		case DEPARTMENT_DEL_USER_FAILURE:
			return assign({}, state, {

			});

		//彻底删除员工
		case USER_DEL_REQUEST:
			return assign({}, state, {

			});
		case USER_DEL_SUCCESS:
			return assign({}, state, {
			});
		case USER_DEL_FAILURE:
			return assign({}, state, {

			});
		//角色
		case ROLE_LIST_REQUEST:
			return assign({}, state, {

			});
		case ROLE_LIST_SUCCESS:
			return assign({}, state, {
				roleList: action.response.result.info,
			});
		case ROLE_LIST_FAILURE:
			return assign({}, state, {
			});
		//任务
		case ROLE_TREE_REQUEST:
			return assign({}, state, {

			});
		case ROLE_TREE_SUCCESS:
			return assign({}, state, {
				taskTree: action.response.result.info,
			});
		case ROLE_TREE_FAILURE:
			return assign({}, state, {
			});
		//更新员工
		case USER_UPDATE_REQUEST:
			return assign({}, state, {

			});
		case USER_UPDATE_SUCCESS:
			return assign({}, state, {
			});
		case USER_UPDATE_FAILURE:
			return assign({}, state, {

			});
		//创建角色并关联任务
		case ROLE_ADD_REQUEST:
			return assign({}, state, {
			});
		case ROLE_ADD_SUCCESS:
			return assign({}, state, {
			});
		case ROLE_ADD_FAILURE:
			return assign({}, state, {
			});
		//更新角色并关联任务
		case ROLE_Edit_REQUEST:
			return assign({}, state, {
			});
		case ROLE_Edit_SUCCESS:
			return assign({}, state, {
			});
		case ROLE_Edit_FAILURE:
			return assign({}, state, {
			});
		//删除角色
		case ROLE_DEL_REQUEST:
			return assign({}, state, {
			});
		case ROLE_DEL_SUCCESS:
			return assign({}, state, {
			});
		case ROLE_DEL_FAILURE:
			return assign({}, state, {
			});

		// 关键字查询 user & department
		case ORGANIZATION_USER_GLOBAL_INQUIRE_REQUEST:
			return assign({}, state, { showLoading: true })
		case ORGANIZATION_USER_GLOBAL_INQUIRE_SUCCESS:
			return assign({}, state, {
				showLoading: false,
				filterUserDepartment: action.response.result.list,
			})
		case ORGANIZATION_USER_GLOBAL_INQUIRE_FAILURE:
			return assign({}, state, { showLoading: false })

		default:
			return state;
	}
}

export default getReducer(index);


// WEBPACK FOOTER //
// ./src/reducer/org/index.js